


































































































































































































































































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import store from "../store/index";

export default Vue.extend({
  name: "CheckResult",
  computed: mapState({
    checkInfo: (state: any) => store.getters.getCheckInfo,
    isTermsCopyPercent: () =>
      store.getters.getCheckInfo.reportModel &&
      store.getters.getCheckInfo.reportModel.copyPercent.termsCopyPercent,
    productId: (state: any) => store.getters.getProductId,
  }),
  data() {
    return {};
  },
  methods: {
    // 初始化检测结果
    initCheckResult() {
      // console.log('检测结果');
    },
  },
  mounted() {
    this.initCheckResult();
  },
});
